module.exports = __webpack_public_path__ + "static/media/shop-wedding-ring-banner.dc226ca9.png";